import { render, staticRenderFns } from "./VirtualManager.vue?vue&type=template&id=2d065d79&scoped=true&"
import script from "./VirtualManager.script.js?vue&type=script&lang=js&"
export * from "./VirtualManager.script.js?vue&type=script&lang=js&"
import style0 from "./VirtualManager.scss?vue&type=style&index=0&id=2d065d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d065d79",
  null
  
)

export default component.exports